// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { ProviderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveProviderConfiguration: () => UseMutationResult<
  void,
  string,
  {
    providerServiceCid: ContractId<ProviderService>;
    providerConfigurationCid: ContractId<ProviderConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveProviderConfiguraiton', ledgerApi],
    mutationFn: async ({ providerServiceCid, providerConfigurationCid }) => {
      return ledgerApi.archiveRegistryProviderConfiguration(
        providerServiceCid,
        providerConfigurationCid,
      );
    },
  });
};

export default useArchiveProviderConfiguration;
